import styled from "@emotion/styled"

const ListTwoCardText = styled.div`
  margin-top: 0;
  font-size: 18px;
  line-height: 29px;
  margin-bottom: 0;
  white-space: pre-wrap;
  font-weight: 400;

  p {
    margin: 0;
    opacity: 90%;
    text-align: left;
  }

  ${({ theme }) => theme.breakpoints.down("lg")} {
    line-height: 25px;
  }

  ${({ theme }) => theme.breakpoints.up("lg")} {
    line-height: 29px;
  }
`

export default ListTwoCardText
